import { render, staticRenderFns } from "./purchaseAccountAction.vue?vue&type=template&id=3188ff3e&scoped=true"
import script from "./purchaseAccountAction.vue?vue&type=script&lang=js"
export * from "./purchaseAccountAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseAccountAction.vue?vue&type=style&index=0&id=3188ff3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188ff3e",
  null
  
)

export default component.exports